import React from 'react'
import './styles.scss'

export const Isotype = ({
  data,
  x,
  y,
  xOffset,
  yOffset,
  icon,
  direction = 'lr',
  wrapAfter
}: {
  data: string[][]
  x: number
  y: number
  xOffset: number
  yOffset: number
  icon: JSX.Element
  direction?: 'lr' | 'rl'
  wrapAfter?: number
}) => {
  return (
    <g {...transform(x, y)}>
      {data.map((m, i) => {
        return (
          <Row
            key={i}
            data={m}
            offsetX={xOffset}
            y={i * yOffset}
            offsetY={yOffset}
            IconComp={icon}
            direction={direction}
            wrapAfter={wrapAfter}
          />
        )
      })}
    </g>
  )
}

const Row = ({
  data,
  offsetX,
  offsetY,
  y,
  IconComp,
  direction,
  wrapAfter = 10
}: {
  data: string[]
  offsetX: number
  offsetY: number
  y: number
  IconComp: JSX.Element
  direction: 'lr' | 'rl'
  wrapAfter?: number
}) => {
  const Icons = data.map((a, i) => {
    const linecount = Math.floor(i / wrapAfter) || 0
    const x = (i - linecount * wrapAfter) * offsetX || 0
    return (
      <g
        key={i}
        {...transform(direction === 'rl' ? -x : x, linecount * offsetY)}
      >
        <Icon comp={IconComp} className={a} />
      </g>
    )
  })
  return (
    <g className='iconrow' {...transform(0, y)}>
      {Icons}
    </g>
  )
}

const Icon = ({
  comp,
  className
}: {
  comp: JSX.Element
  className: string
}) => {
  return <> {React.cloneElement(comp, { className: `icon ${className}` })}</>
}

const transform = (x: number = 0, y: number = 0, s?: number) => ({
  transform: `translate(${x},${y})` + (s ? `scale(${s})` : '')
})
